var _c;
// import { ProGalleryOptions } from './gallery.types';
import { optionsMap, galleryOptions, isInPreset, addPresetOptions, extendNestedOptionsToIncludeOldAndNew, populateWithDefaultOptions, GALLERY_CONSTS, } from 'pro-gallery-lib';
import optionsConverter from './proGalleryOptionsBuilder';
import { PRIVATE_CONTROLLERS } from './controllers/private-controllers';
var getTrue = function () { return true; };
var isNewInfoExperimentOpen = function (experimentalFeatures) { return experimentalFeatures.newInfoElements === true; };
var getIsOldInfo = function (_a, _b, _experimentalFeatures) {
    return !isNewInfoEnabledByUser(_a);
    // if (isNewInfoExperimentOpen(experimentalFeatures)) {
    //   return false
    // }
    // return true
};
function isNewInfoEnabledByUser(opts) {
    var _c, _d;
    return ((_d = (_c = opts === null || opts === void 0 ? void 0 : opts.controllers) === null || _c === void 0 ? void 0 : _c.experimental) === null || _d === void 0 ? void 0 : _d.useNewInfo) === 'true';
}
var getIsNewInfo = function (_a, _b, _experimentalFeatures) {
    return isNewInfoEnabledByUser(_a);
    // debugger
    // return isNewInfoExperimentOpen(experimentalFeatures)
};
var infoPlacementExternalIsEnabled = function (infoPlacement) { return !GALLERY_CONSTS.isHoverPlacement(infoPlacement); };
var overlayRelevant = function (hoveringBehavior) { return GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW !== hoveringBehavior; };
var isRelenvatInternal = function (options, _b, experimentalFeatures) {
    if (getIsNewInfo(options, _b, experimentalFeatures) === false) {
        return false;
    }
    if (options.behaviourParams.item.overlay.hoveringBehaviour === 'NEVER_SHOW') {
        return false;
    }
    return true;
};
var isStylableInnerTitleRelevant = function (opts) {
    var hoveringBehaviour = opts.behaviourParams.item.overlay.hoveringBehaviour;
    return isInfoTypeEnabledInNewInfo('Title', 'internal', opts) || (opts.allowTitle && overlayRelevant(hoveringBehaviour));
};
var isStylableInnerDescriptionRelevant = function (opts) {
    var hoveringBehaviour = opts.behaviourParams.item.overlay.hoveringBehaviour;
    return isInfoTypeEnabledInNewInfo('Description', 'internal', opts) || (opts.allowDescription && overlayRelevant(hoveringBehaviour));
};
var isStylableExternalTitleRelevant = function (opts) {
    var infoPlacement = opts.layoutParams.info.placement;
    var allowInfoPlacement = galleryOptions[optionsMap.layoutParams.info.placement].isRelevant(opts, null);
    return isInfoTypeEnabledInNewInfo('Title', 'external', opts) || (opts.allowTitle && allowInfoPlacement && infoPlacementExternalIsEnabled(infoPlacement));
};
var isStylableExternalDescriptionRelevant = function (opts) {
    var infoPlacement = opts.layoutParams.info.placement;
    var allowInfoPlacement = galleryOptions[optionsMap.layoutParams.info.placement].isRelevant(opts, null);
    return isInfoTypeEnabledInNewInfo('Description', 'external', opts) || (opts.allowDescription && allowInfoPlacement && infoPlacementExternalIsEnabled(infoPlacement));
};
var shouldShowExternalSection = function (_a, _b, _experimentalFeatures) {
    // TODO: The isInPreset part should be convert to a map between PRIVATE_CONTROLLERS and coreKeys. Once 
    // we will have this map, the isInPreset condition in the generic _isRelevant should use that map to send the correct key to the core function isInPreset.
    // For example the generic code 
    // 
    // if(isInPreset(galleryLayout, paramName)) {
    //   return false
    // }
    //
    // Should change to 
    // if(isInPreset(galleryLayout, getCoreKey(paramName))) {
    //   return false
    // }
    //
    // The getCoreKey will have a mapping like this
    // {
    //      "controllers_layoutParams_infoElementOptions_external_order": "layoutParams_info_placement"
    // }
    return (getIsNewInfo(_a, _b, _experimentalFeatures)) && (isInPreset(_a.galleryLayout, 'layoutParams_info_placement') === false);
};
var settingsOptions = (_c = {},
    _c[optionsMap.behaviourParams.item.content
        .placementAnimation] = getTrue,
    _c[PRIVATE_CONTROLLERS.VIDEO.VOLUME] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO
        .ALLOW_TITLE_AND_DESCRIPTION] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING] = getIsOldInfo,
    // @ts-ignore
    _c[PRIVATE_CONTROLLERS.INFO.USE_NEW_INFO] = function (_a, _b, _experimentalFeatures) {
        return _experimentalFeatures.newInfoElements === true;
    },
    _c[PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO
        .EXTERNAL_MASTER_INFO_ENABLED] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO
        .EXTERNAL_MASTER_INFO_ORDER] = shouldShowExternalSection,
    _c[optionsMap.layoutParams.info.placement] = getIsOldInfo,
    _c[PRIVATE_CONTROLLERS.INFO
        .EXTERNAL_INFO_PLACEMENT] = shouldShowExternalSection,
    _c[PRIVATE_CONTROLLERS.INFO
        .INTERNAL_MASTER_INFO_ENABLED] = isRelenvatInternal,
    _c[PRIVATE_CONTROLLERS.INFO
        .INTERNAL_MASTER_INFO_ORDER] = isRelenvatInternal,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_TITLE] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_DESCRIPTION] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_LINK] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.WHEN_TO_SHOW_INFO] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.EXPAND_INFO_POSITION] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.SHOW_INFO_BUTTON] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_FULLSCREEN_EXPAND] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.LOOP] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_MAGNIFY_IMAGE] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.MAGNIFICATION_LEVEL] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_BLUR_FILTER] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER] = getTrue,
    _c[PRIVATE_CONTROLLERS.FULLSCREEN.FULLSCREEN_PREVIEW] = getTrue,
    _c[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL] = function (opts) {
        var unit = opts.layoutParams.info.sizeUnits;
        return (galleryOptions[optionsMap.layoutParams.info.width].isRelevant(opts, null) && unit === 'PIXEL');
    },
    _c[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT] = function (opts) {
        var unit = opts.layoutParams.info.sizeUnits;
        return (galleryOptions[optionsMap.layoutParams.info.width].isRelevant(opts, null) && unit === 'PERCENT');
    },
    _c['OVERLAY'] = function (opts) {
        return galleryOptions[optionsMap.behaviourParams.item.overlay.size].isRelevant(opts, null);
    },
    _c[PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE] = function (opts) {
        return galleryOptions[optionsMap.behaviourParams.item.overlay.size].isRelevant(opts, null);
    },
    _c[optionsMap.behaviourParams.item.overlay.sizeUnits] = function (opts) {
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts, null) && type === 'PARTIAL');
    },
    _c[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT] = function (opts) {
        var unit = opts.behaviourParams.item.overlay.sizeUnits;
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts, null) &&
            unit === 'PERCENT' &&
            type === 'PARTIAL');
    },
    _c[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL] = function (opts) {
        var unit = opts.behaviourParams.item.overlay.sizeUnits;
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.sizeUnits].isRelevant(opts, null) &&
            unit === 'PIXEL' &&
            type === 'PARTIAL');
    },
    _c[optionsMap.behaviourParams.item.overlay.position] = function (opts) {
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.position].isRelevant(opts, null) && type === 'PARTIAL');
    },
    _c[optionsMap.behaviourParams.item.overlay.padding] = function (opts) {
        var type = opts.controllers.behaviourParams.item.overlay.overlayType;
        return (galleryOptions[optionsMap.behaviourParams.item.overlay.padding].isRelevant(opts, null) && type === 'PARTIAL');
    },
    _c[PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_METHOD] = function (_opts) {
        return galleryOptions[optionsMap.layoutParams.structure.galleryRatio.value].isRelevant(_opts, null);
    },
    _c[PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_VALUE] = function (_opts) {
        return (_opts.controllers.layoutParams.structure.galleryRatio.method ===
            'FIXED' &&
            galleryOptions[optionsMap.layoutParams.structure.galleryRatio.value].isRelevant(_opts, null));
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.GALLERY] = getTrue,
    _c[PRIVATE_CONTROLLERS.STYLABLE.CONTAINER] = getTrue,
    _c[PRIVATE_CONTROLLERS.STYLABLE.ITEM] = getTrue,
    _c[PRIVATE_CONTROLLERS.STYLABLE.ITEM_HOVER] = getTrue,
    _c[PRIVATE_CONTROLLERS.STYLABLE.ITEM_CONTENT] = getTrue,
    _c[PRIVATE_CONTROLLERS.STYLABLE.ITEM_CONTENT_HOVER] = getTrue,
    _c[PRIVATE_CONTROLLERS.STYLABLE.ITEM_OVERLAY] = function (opts) {
        var type = opts.behaviourParams.item.overlay.hoveringBehaviour;
        return overlayRelevant(type);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.ITEM_OVERLAY_HOVER] = function (opts) {
        var type = opts.behaviourParams.item.overlay.hoveringBehaviour;
        return overlayRelevant(type);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.INNER_DESCRIPTION] = function (opts) {
        if (isNewInfoEnabledByUser(opts)) {
            return false;
        }
        return isStylableInnerDescriptionRelevant(opts);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.INNER_TITLE] = function (opts) {
        if (isNewInfoEnabledByUser(opts)) {
            return false;
        }
        return isStylableInnerTitleRelevant(opts);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_TITLE] = function (opts) {
        if (isNewInfoEnabledByUser(opts)) {
            return false;
        }
        return isStylableExternalTitleRelevant(opts);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_DESCRIPTION] = function (opts) {
        if (isNewInfoEnabledByUser(opts)) {
            return false;
        }
        return isStylableExternalDescriptionRelevant(opts);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.INNER_DESCRIPTION_REGULAR] = function (opts) {
        return isNewInfoEnabledByUser(opts) && isStylableInnerDescriptionRelevant(opts);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.INNER_TITLE_REGULAR] = function (opts) {
        return isNewInfoEnabledByUser(opts) && isStylableInnerTitleRelevant(opts);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_TITLE_REGULAR] = function (opts) {
        return isNewInfoEnabledByUser(opts) && isStylableExternalTitleRelevant(opts);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_DESCRIPTION_REGULAR] = function (opts) {
        return isNewInfoEnabledByUser(opts) && isStylableExternalDescriptionRelevant(opts);
    },
    _c[PRIVATE_CONTROLLERS.STYLABLE.LOAD_MORE] = function (opts) {
        return opts.behaviourParams.gallery.vertical.loadMore.enable && galleryOptions[optionsMap.behaviourParams.gallery.vertical.loadMore.enable].isRelevant(opts, null);
    },
    _c);
function isInfoTypeEnabledInNewInfo(infoType, internalOrExternalType, opts) {
    if (!isNewInfoEnabledByUser(opts)) {
        return false;
    }
    return opts.controllers.layoutParams.infoElementOptions[internalOrExternalType].enabled.includes(infoType);
}
var isRelevant = function (paramName, settingOptions, enumOption, experimentaFeatures, optionsEnableMap) {
    var _c;
    if (settingOptions === void 0) { settingOptions = {}; }
    if (experimentaFeatures === void 0) { experimentaFeatures = {}; }
    if (optionsEnableMap === void 0) { optionsEnableMap = {}; }
    var shouldUseNewInfo = isNewInfoExperimentOpen(experimentaFeatures);
    var newSettingsOptions = optionsConverter(settingOptions, shouldUseNewInfo).galleryOptions;
    var migratedOptions = extendNestedOptionsToIncludeOldAndNew(newSettingsOptions);
    var migratedOptionsWithDefaultsOptions = populateWithDefaultOptions(migratedOptions);
    var options = addPresetOptions(migratedOptionsWithDefaultsOptions);
    var galleryLayout = options.galleryLayout;
    var optionEnable = (enumOption === undefined || enumOption === null) ? optionsEnableMap[paramName] : optionsEnableMap["".concat(paramName, ".").concat(enumOption)];
    var optionDisabled = optionEnable && optionEnable.enabled === false;
    if (optionDisabled) {
        return false;
    }
    var isRelevantFunc = (settingsOptions === null || settingsOptions === void 0 ? void 0 : settingsOptions[paramName]) || ((_c = galleryOptions[paramName]) === null || _c === void 0 ? void 0 : _c.isRelevant);
    var isRelevantResult = !!isRelevantFunc && isRelevantFunc(options, enumOption, experimentaFeatures);
    if (paramName === optionsMap.layoutParams.structure.galleryLayout) {
        // for some reason the galleryLayout param appear on each preset
        return true;
    }
    if (isInPreset(galleryLayout, paramName)) {
        return false;
    }
    return isRelevantResult;
};
export default isRelevant;
//# sourceMappingURL=isRelevant.js.map